export const environment = {
  version: '1.0.22.01',
  production: true,
  inactivityTimeout: 60,
  settingsSyncInterval: 10,
  applicationUpdateInterval: 10,
  whitelistedDomains: [
    'localhost:4200',
    'stockcare-dev-web.atajo.io',
    'stockcare-clinix.atajo.io',
    'stockcare-clinix-qas.atajo.io',
    'stockcare-clinix-dev.atajo.io',
    'stockcare-lenmed.atajo.io',
    'stockcare-lenmed-qas.atajo.io',
    'stockcare-lenmed-dev.atajo.io',
    'stockcare-demo.atajo.io',
  ],
  encryptionSecret: 'Xk9#mP2$vQ7@nL4&wR6!jT8*yF3^hN5',
};
